import React, { useState, useContext } from 'react';
import { WebTagContext } from '../../context/WebTagContext';
import { environment } from '../../global/environment';
import { useFetch } from '../../hooks/useFetch';

export const WebTagStep1 = () => {
    const { step, setStep } = useContext(WebTagContext);

    const { api_url, parking_conditions_endpoint } = environment;

    const { response: conditions } = useFetch( api_url, parking_conditions_endpoint );
    
    const [ showConditions, setShowConditions ] = useState( false );
    
    const handleHeaderClick = () => {
        ( step.current > 1 && step.current !== 4 ) &&
            setStep( { current: 1 } );
    }

    const handleClick = () => {
        setStep({
            current: 2
        })
    }

    const handleSetConditions = ( e, show ) => {
        e.preventDefault();
        setShowConditions( show );
    }

    return (
        <div className="step">
            <div className="step-header">
                <a 
                    onClick = { handleHeaderClick }
                    className="title">
                    <span className={ step.current > 1 ? "completed step-number" : "step-number"}>
                        <span>1</span>
                    </span>Nueva solicitud
                </a>
            </div>
            { 
                step.current === 1 
                && 
                <>
                    <div className="step-container">
                        <p>Este formulario es para la solicitud de alta del tag de Telepeaje.</p>
                        {/* <p>Si Ud. es SOCIO debe realizar el ALTA del TAG por la APP.</p> */}
                        { !showConditions &&
                            <a 
                                href="#"
                                onClick = { (e) => handleSetConditions( e, true ) } >
                                    Condiciones de Uso del Parking
                            </a>
                        }
                        { ( conditions.__html && showConditions ) &&
                            <>
                                <div 
                                    dangerouslySetInnerHTML = { conditions } 
                                    style = {{ marginTop: "15px" }}/>     
                                <a 
                                    href="#"
                                    onClick = { (e) => handleSetConditions( e, false ) } >Ocultar condiciones</a>                 
                            </>
                        }
                    </div>
                    <div className="no-margin step-actions">
                        <button 
                                className="btn-form"
                                onClick = { handleClick }>Continuar</button>
                    </div>
                </>
            
            }
        </div>
    );
}
